import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMicrophone } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';

import { Textarea } from '../../components/utils/Input';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import validateManyFields from '../../validations';
import AILightComponent from '../../components/AILightComponent';
import '../../styles/Concerns.css';
import { GenerateApplauseCode } from '../../components/GenerateThink5whysCode';

const ApplauseMarksheet = () => {

  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { applauseId } = useParams();

  const mode = applauseId === undefined ? "add" : "update";
  const [applause, setApplause] = useState(null);

  const [formErrors, setFormErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [countFormErrors, setCountFormErrors] = useState(0);

  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [nameCodeVerified, setNameCodeVerified] = useState(false);
  const [nameCodeStatus, setNameCodeStatus] = useState(false);
  const [nameCodeStatusMsg, setNameCodeStatusMsg] = useState(false);
  const [error, setError] = useState(null);
  
  const [marksheetMegaPrizes, setMarksheetMegaPrizes] = useState(false);

  // const [nameCodeId, setNameCodeId] = useState('');
  const [name, setName] = useState('');
  const [nameCode, setNameCode] = useState('');

  const autoApplauseCode = GenerateApplauseCode();
  const [formData, setFormData] = useState({
    user: authState.user._id,
    userName: authState.user.name,
    applauseTo: "",
    applauseFor: "Marksheet",
    title: "",
    school: "",
    student: "",
    profession: "",
    applauseDate: new Date(),
    description: "",
    name: "",
    tags: "",
    isActive: true,
    isDeleted: false,
    remarks: "",
    nameCode: '', //authState.user.think5whyscode,
    applauseCode: autoApplauseCode,
    reply: "",
    replyDate: null,
    isMarksheetMegaPrize: true,
    overallMarks: 0,
    favSubject: '',
    subjectMarks: 0,
    dateMarksheet: new Date(),
    isAgreed: true,
    influencerCode: '',
    instagramId: '',
    applauseGroupCode: "",
  });

  useEffect(() => {
    document.title = mode === "add" ? "Add Applause" : "Update Applause";
  }, [mode]);


  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/applause/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {applauseId: applauseId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false }).then((data) => {
        // console.log("response for update - ",data.applause);
        // console.log("response ",data.applause.applauseDate);
        setApplause(data.applause);
        setFormData({ 
          user: data.applause.user,
          userName: data.applause.userName,
          applauseTo: data.applause.applauseTo,
          applauseFor: data.applause.applauseFor,
          title: data.applause.title,
          school: data.applause.school,
          student: data.applause.student,
          profession: data.applause.profession,
          applauseDate: new Date(data.applause.applauseDate),
          description: data.applause.description,
          name: data.applause.name,
          tags: data.applause.tags,
          isActive: data.applause.isActive,
          isDeleted: data.applause.isDeleted,
          remarks: data.applause.remarks,
          nameCode: data.applause.nameCode, 
          applauseCode: data.applause.applauseCode,
          reply: data.applause.reply,
          replyDate: data.applause.replyDate,
          isMarksheetMegaPrize: data.applause.isMarkesheetMegaPrize,
          overallMarks: data.applause.overallMarks,
          favSubject: data.applause.favSubject,
          subjectMarks: data.applause.subjectMarks,
          dateMarksheet: data.applause.dateMarksheet,
          isAgreed: data.applause.isAgreed,
          influencerCode: data.applause.influencerCode,
          instagramId: data.applause.instagramId,  
          applauseGroupCode: data.applause.applauseGroupCode,       
        });
      });
    }
  }, [mode, authState, applauseId, fetchData]);



  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/applause", 
        method: "post", 
        data: {formData: formData, user: authState.user._id},
        headers: { Authorization: authState.token } 
      };
      fetchData(config).then(() => {
        navigate("/i-applauded-marksheet");
      });
    }
    else {
      const config = { 
        url: `/applause/${applauseId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      fetchData(config).then(() => {
        navigate("/i-applauded-marksheet");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.applauseTo) {
      errors.applauseTo = "Please select an applausee!";
    }
    if (!formData.title) {
      errors.title = "Title is required!";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters!";
    }
    if (!formData.overallMarks) {
      errors.overallMarks = "Overall Marks is required!";
    }
    if (!formData.isAgreed) {
      errors.isAgreed = "You must accept the Rules & Guidelines!";
    }
    if (!formData.favSubject) {
      errors.favSubject = "Favourite Subject is required!";
    }
    if (!formData.subjectMarks) {
      errors.subjectMarks = "Subject Marks is required!";
    }
    if (!formData.dateMarksheet) {
      errors.dateMarksheet = "Marksheet Date is required!";
    } else {
      const currentDate = new Date();
      const enteredDate = new Date(formData.dateMarksheet);

      if (enteredDate > currentDate) {
        errors.dateMarksheet = "Marksheet Date cannot be a future date!";
      }
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  const handleMicrophoneClick = () => {
    setShowMicrophoneAlert(true);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  
const [nameCodeVerifyClicked, setNameCodeVerifyClicked] =useState(false);

const handleNameCodeVerifyClick = () => {
  // console.log("handleNameCodeVerifyClick", formData);
  setError("");
  setNameCodeVerifyClicked(true);
  
  // Validate Payee Code
  if (/^TU[a-zA-Z0-9]{12}$/.test(formData.nameCode)) {
        fetchNameCode(formData.nameCode);
  } else {
      setError('Please enter a valid 14-character Think5Whys user code starting with TU.');
  }
  if (formData.nameCode === authState.user.think5whyscode) {
    setError('This is your Self Code!!! Input Another Code!');
  }
};


const fetchNameCode = useCallback((nameCode) => {
  // console.log("fetchNameCode for API call ", nameCode);
  const config = {
      url: "/auth/verifycodeforapplause",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: nameCode }
  };

  fetchData(config)
      .then(response => {
        // console.log("API Response: ", response); 
          if (response && response.status) {
              // console.log("Aplausee found ", response);
              setNameCodeStatus(true);
              setNameCode(response.t5wcode._id);
              setName(response.t5wcode.name);
              // Update formData.name with the response name
              setFormData(prevFormData => ({
                ...prevFormData,
                name: response.t5wcode.name
              }));
              setNameCodeStatusMsg("Code found. 😊");
              // console.log("Payee Code found");
          } else {
              // console.log("Code Not found else");
              setNameCodeStatus(false);
              setNameCodeStatusMsg(`Code ${payeeCode} not found! 😔 Make sure the Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("Code Not found! catch", error);
          setNameCodeStatus(false);
          setNameCodeStatusMsg("Think5Whys Code Not Found!! Please input correct code.");
      });
}, [fetchData, authState.token]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchNameCode]);

  return (
    <div className='bg-black [&_p]:text-white'>
      <div className="min-h-full py-2 black rounded-lg">
        <h3 className='text-lg lg:text-xl font-bold text-yellow-200 text-center mb-6'>Applause and Turn Your Markesheet Into Mega Prizes</h3>
        {loading ? (
          <Loader />
        ) : (
          <div className='text-sm [&_p]:text-white'>
            <div className='flex justify-center'>
              <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add New Applause" : "Edit Applause"}</h2>
            </div>
            <div className="border-container">
                <p className="text-white">Your Visible Appaluse Code: {autoApplauseCode}</p>
                <p className="text-yellow-300">The appraisee except parent / grand parent must me a registered user on the platform</p>
            </div>
            <div className="border-container">
              <div className="mb-4">
                <label htmlFor="applauseTo">Applause Marks of:*</label>
                <br />
                <select name="applauseTo" id="applauseTo" value={formData.applauseTo}
                  onChange={handleChange} className='text-sm' style={{ border: '1px solid #ccc', height: '36px', padding: '8px' }}>
                  <option value="">Select Whom to Applause</option>
                  <option value="Self">Self</option>
                  <option value="Parent">Parent</option>
                  <option value="Children">Children</option>
                  <option value="Friend">My Friend</option>
                  <option value="Student">My Student</option>
                </select>
                {fieldError("applauseTo")}
              </div>
              { formData.applauseTo !=="Self" && formData.applauseTo !== "Parent" && (
                <>
                <div className="border-container flex flex-col text-white">
                  <p>Input Person Think5Whys User Code*:</p>
                  <p className='text-yellow-200 text-sm mb-4'>(Ask the person's 14 character User Code. Its availabe in Dashbaord / Home - Personal Information - My prfile - My Think5Whys Code) </p>
                  <input
                    type="text"
                    className="profile-input text-black py-2 px-4 "
                    style={{ width: '200px'}}
                    value={formData.nameCode}
                    onChange={(e) => setFormData({ ...formData, nameCode: e.target.value })}
                    placeholder="Input Code here"
                  />
                  <div className="mb-6 text-center">
                    <p className={nameCodeStatus ? "text-green-500 text-lg" : "text-red-500 text-lg"}>
                      {nameCodeStatusMsg}
                    </p>
                  </div>
                  <div className='flex flex-row'>
                    <button
                      className='bg-orange-700 py-2 px-4 '
                      onClick={()=>handleNameCodeVerifyClick()}
                      disabled={nameCodeStatus}
                    >
                      {nameCodeStatus ? "Think5Whys Code Validated" : "Validate Think5Whys Code"}
                    </button>
                    <button
                      onClick={handleCancelClick}
                      className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                    >
                      Back
                    </button>
                  </div>
                </div>
                <div className="text-center mb-6">
                  <p className={nameCodeStatus ? "text-green-400" : "text-red-400"}>
                    <strong className="text-xl">{setNameCodeStatusMsg}</strong>
                  </p>
                </div>

                { nameCodeStatus && (
                  <div className='mb-4 '>
                    <p className=" text-white">Code: </p>
                    <p className="text-yellow-300 ">{mode==="add" ? nameCode : formData.nameCode}</p>
                    <p className=" text-white"> Name:</p>
                    <p className="text-yellow-300 ">{mode==="add" ? name : formData.name}</p>
                  </div>
                )}
              </>
              )}
              <div className="mb-4">
                <label htmlFor="title">Exam Name:*</label>
                <br />
                <input 
                  type="text" 
                  name="title" 
                  id="title" 
                  value={formData.title} 
                  placeholder="Enter the heading / title..."
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '450px' }} 
                />
                {fieldError("title")}
              </div> 
              <div className="mb-4">
                <label htmlFor="school">School / College / Board / University:</label>
                <br />
                <input 
                  type="text" 
                  name="school" 
                  id="school" 
                  value={formData.school} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '450px' }} 
                />
                {fieldError("school")}
              </div> 
              <div className="mb-4">
                <label htmlFor="student">Student Name:</label>
                <br />
                <input 
                  type="text" 
                  name="student" 
                  id="student" 
                  value={formData.student} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '300px' }} 
                />
                {fieldError("student")}
              </div> 
              { formData.applauseTo === "Parent" && (
                <div className="mb-4">
                  <label htmlFor="student">Parent/Grandparent Profession:</label>
                  <br />
                  <input 
                    type="text" 
                    name="profession" 
                    id="profession" 
                    value={formData.profession} 
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '300px' }} 
                  />
                  {fieldError("profession")}
                </div> 
              )}
              <div className="mb-4">
                <label htmlFor="overallMarks">Overall % Marks:*</label>
                <br />
                <input 
                  type="number" 
                  name="overallMarks" 
                  min="0" 
                  max={100}
                  step={1}
                  value={formData.overallMarks} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                />
                {fieldError("overallMarks")}
              </div> 
              <div className="mb-4">
                <label htmlFor="favSubject">Favourite Subject:*</label>
                <br />
                <input 
                  type="text" 
                  name="favSubject" 
                  value={formData.favSubject} 
                  placeholder="Enter the heading / title..."
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '300px' }} 
                />
                {fieldError("favSubject")}
              </div>   
              <div className="mb-4">
                <label htmlFor="subjectMarks">% Marks in the Subject:*</label>
                <br />
                <input 
                  type="number" 
                  name="subjectMarks" 
                  min="0" 
                  max={100}
                  step={1}
                  value={formData.subjectMarks} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                />
                {fieldError("subjectMarks")}
              </div>      
              <div className="mb-4">
                <label htmlFor="dateMarksheet">Date of Marksheet:*</label>
                <br />
                <DatePicker 
                  selected={formData.dateMarksheet}
                  onChange={date => setFormData({ ...formData, dateMarksheet: date })}
                  dateFormat="dd/MM/yyyy"
                  id="dateMarksheet"
                  name="dateMarksheet" 
                  style={{ border: '1px solid #ccc', padding: '8px'}} 
                />
                {fieldError("dateMarksheet")}
              </div>                       
            </div>

            <div className="border-container">
              <label htmlFor="description">Story / Interesting Incident / Fact (Optional):</label>
              <div className="mb-4">
                <textarea 
                  type="description" 
                  name="description" 
                  id="description" 
                  value={formData.description}
                  onChange={handleChange}
                  maxLength="2000"
                  style={{
                    border: '1px solid #ccc',
                    padding: '2px',
                    backgroundColor: '#f0f0f0', 
                    color: '#000000',
                    width: '100%', 
                    height: '150px' 
                  }}
                />
                {fieldError("description")}
              </div>
            </div>

            <div className="border-container flex flex-col">
              <p className='text-white'>Your Infleuncer Think5Whys Code:</p>
                <br />
                <input 
                  type="text" 
                  name="influencerCode" 
                  value={formData.influencerCode} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} 
                />
                {fieldError("influencerCode")} 
                <p className='text-white'>Instagram Influencer Id:</p>
                <br />
                <input 
                  type="text" 
                  name="instagramId" 
                  value={formData.instagramId} 
                  onChange={handleChange} 
                  style={{ border: '1px solid #ccc', padding: '8px', width: '200px' }} 
                />
                {fieldError("instagramId")}
                <div className='flex flex-row mt-4'>
                  <input 
                    type="checkbox" 
                    className="mr-2 cursor-pointer"
                    checked={formData.isAgreed} 
                    onChange={(e) => setFormData({ ...formData, isAgreed: e.target.checked })} 
                  />
                  <span className="text-m text-white">My all informations are correct. Also I abide by the contest rules.</span>
                  {fieldError("isAgreed")}
                </div>
              </div>
              <div class="flex flex-col mt-2 p-4 bg-black border border-gray-400 text-white shadow-xl rounded-lg space-y-6 max-w-full">
                <h2 class="text-lg lg:text-xl font-bold text-yellow-300 mb-4">Contest Rules</h2>
                <div class="space-y-4 [&_li]:text-white">
                  <ol class="list-decimal pl-6 space-y-4 [&_li]:text-white">
                    <li class="leading-relaxed">
                      <span class="font-semibold">No marksheet proof is required</span> during Applause to self, father, mother, grandfather, grandmother, friend, or student.
                    </li>
                    <li class="leading-relaxed">
                      Prizes will only be awarded to participants providing valid marksheet proof if they win any prizes through a lucky draw.
                    </li>
                    <li class="leading-relaxed">
                      No purchase is required to win <span class="font-semibold">3,00,000 additional early bird prizes</span> (NoteFlex Digital Book & Digital Cards).
                    </li>
                    <li class="leading-relaxed">
                      To qualify for the mega prize under the <span class="font-semibold">"Celebrate 1,00,000 Think5Whys DeepThinking Program Certificate"</span>, you must purchase the Think5Whys Collection, Periodic Collection, CAFE, or MOBook through the referral program only.
                    </li>
                    <li class="leading-relaxed">
                      The lucky draw for the mega prize will occur once <span class="font-semibold">1,00,000 referral purchases</span> are achieved.
                    </li>
                    <li class="leading-relaxed">
                      The leaderboard will be updated regularly, and the final top <span class="font-semibold">10,000 standings</span> will be considered for the lucky draw.
                    </li>
                    <li class="leading-relaxed">
                      If a lucky draw winner fails to provide marksheet proof, their prize will be forfeited and awarded to the next standby participant.
                    </li>
                    <li class="leading-relaxed">
                      Family members of Think5Whys Global DeepTech Solutions founders or employees are not eligible to win any prizes except early bird prizes.
                    </li>
                    <li class="leading-relaxed">
                      Think5Whys Global DeepTech Solutions will never call to deposit any money in lieu of winning the prize. Non-digital prizes will be delivered directly to the winner’s doorstep through a reputed shopping platform or our merchandise partner.
                    </li>
                    <li class="leading-relaxed">
                      Any taxes applicable on high-value prizes must be paid by the winner.
                    </li>
                    <li class="leading-relaxed">
                      Think5Whys Global DeepTech Solutions reserves the right to make final decisions regarding contest-related issues and policies.
                    </li>
                    <li class="leading-relaxed">
                      Think5Whys Global DeepTech Solutions will not be liable for any claims of personal loss or damage arising from this contest.
                    </li>
                    <li class="leading-relaxed">
                      Technical downtime or outages may occur due to updates, server maintenance, or other reasons. Participants are expected to be patient during these periods.
                    </li>
                  </ol>
                </div>
              </div>

              <div class="flex flex-col mt-2 p-4 bg-black border border-gray-400 text-white shadow-xl rounded-lg space-y-6 max-w-full">
                <p className='text-yellow-200 text-sm lg:text-lg'>Transparency Policy</p>
                <p className='text-sm lg:text-lg'>The lucky draw will be conducted through an automated process.</p>
                <p className='text-sm lg:text-lg'>Standby winners will also be declared in every prize category.</p>
                <p className='text-sm lg:text-lg'>Winners name with their place, state & pincode will be published in the Winner List page.</p>
              </div>
              <div class="flex flex-col mt-8 p-8 bg-gradient-to-b from-slate-700 to-slate-900 text-white shadow-xl rounded-lg space-y-6 max-w-full">
                <span className="text-m lg:text-lg">Disclaimer:</span> This contest is purely for fun and promotional purposes. Think5Whys Global DeepTech Solutions will not share or sell participant information to any coaching institutes or tutorials.
              </div>
              <div class="flex flex-col mt-8 p-8 bg-gradient-to-b from-slate-700 to-slate-900 text-white shadow-xl rounded-lg space-y-6 max-w-full">
                <span className="text-yellow-500 text-m lg:text-lg">Caution: Think5Whys Global DeepTech Solutions will never ask winners to deposit money in exchange for their prize. Non-digital prizes will be delivered to winners' doorsteps through a reputable shopping platform or our merchandise partner.</span>
              </div>

          <div className="border-container flex flex-col justify-center">
            <div className="flex justify-center">
              {Object.keys(formErrors).length > 0 && (
                <div className="form-errors text-red-300 justify-center items-center">
                  {Object.keys(formErrors).map((key) => (
                    <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                  ))}
                </div>
              )}
            </div>
            <div className="flex justify-center">
              <button 
                className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                disabled={(!nameCodeStatus && formData.applauseTo !=="Self" && formData.applauseTo !== "Parent") && mode=== "add"}
                onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}
              </button>
              <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate("/applause-hub-home")}>Back</button>
              {/* {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>} */}
            </div>
          </div>  
        </div>
        )}
      </div>
      <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>           
    </div>
  )
}

export default ApplauseMarksheet